import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import axios from 'axios';

const PlatformContext = createContext();

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const publicAxios = axios.create({ withCredentials: false });

export const PlatformProvider = ({ children }) => {
    const [platformInfo, setPlatformInfo] = useState({
        platform_name: "eDisplayroom",
        platform_tagline: "by Infinity Funeral Supply",
        platform_logo_url: "",
        support_email: "",
        support_phone: "",
        footer_copyright_text: "",
        primary_color: "#000000",
        font: "Inter"
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchPlatformInfo = useCallback(async () => {
        try {
            setLoading(true);
            const response = await publicAxios.get(`${API}/platform-info`);
            setPlatformInfo(response.data);
            setLoading(false);
        } catch (err) {
            console.error("Failed to fetch platform info:", err);
            setError(err);
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchPlatformInfo();
    }, [fetchPlatformInfo]);

    return (
        <PlatformContext.Provider value={{ platformInfo, loading, error, refreshPlatformInfo: fetchPlatformInfo }}>
            {children}
        </PlatformContext.Provider>
    );
};

export const usePlatformContext = () => {
    const context = useContext(PlatformContext);
    if (!context) {
        throw new Error('usePlatformContext must be used within a PlatformProvider');
    }
    return context;
};
